import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
  selector: 'app-delete-meeting-popup',
  templateUrl: './delete-meeting-popup.component.html',
  styleUrls: ['./delete-meeting-popup.component.css']
})
export class DeleteMeetingPopupComponent implements OnInit {
  meetingId: any;
  reason:any
  private readonly notifier!: NotifierService;

  constructor(private permissionService:PermissionService,private util:UtilityService,notifierService: NotifierService,private sideNav : SideNavServiceService,private meetingService: MeetingService,private _mdr: MatDialogRef<DeleteMeetingPopupComponent>,@Inject(MAT_DIALOG_DATA) data: any) { 
    this.notifier = notifierService;
    //this.meetingId = data.meetingId;
    this.meetingId = data['meetingId'];
  }

  ngOnInit(): void {
  }
  alertDeleteMeeting(message : any){
    
  }
  deleteMeeting(){
   
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.DELETE);
    if(!accessFlag){
      return;
    }
    var deleteMeetingJson = {
      "meetingId":this.meetingId,
      "cancelledReason":this.reason
    };


    if(this.reason != null && this.reason != undefined && this.reason!="null" && this.reason != ""){

      this.meetingService.deleteMeeting(deleteMeetingJson).subscribe((resp:any)=>{

        this.notifier.show({
          type: 'success',
          message: 'Meeting Deleted Successfully'
        });
        this._mdr.close(false)
      });
    }else{
      this.sideNav.alertMeetingReason('Enter reason for deletion','error');
    }
  }
  closeDialog() {
    this._mdr.close(false)
  }

}
